import { create } from "zustand";
import { subscribeWithSelector } from "zustand/middleware";

interface ConfigurationFilterState {
  filters: Record<string, any>;
  setFilters: (filters: Record<string, any>) => void;
}

export const useFilterConfigurationStore = create<ConfigurationFilterState>()(
  subscribeWithSelector((set) => ({
    filters: {},
    setFilters: (filters) => set({ filters }),
  }))
);